// breadcrumbConfig.js
const breadcrumbConfig = {
  //   "/dashboard": [
  //     { label: "Home", path: "/" },
  //     { label: "Dashboard", path: "/dashboard" },
  //   ],
  "/services/daily-booking": [
    { label: "Home", path: "/" },
    {
      label: "Daily Puja Booking Service",
      path: "/services/daily-puja-booking",
    },
    { label: "Daily Puja Booking", path: "/services/daily-booking" },
  ],

  "/services/book-puja": [
    { label: "Home", path: "/" },

    { label: "Puja Booking Service", path: "/services/puja-booking" },
    { label: "Puja Booking", path: "/services/book-puja" },
  ],
  "/my-store": [
    { label: "Home", path: "/" },

    { label: "Online Puja Samagri Store", path: "/services/e-store" },
    { label: "E-store", path: "/my-store" },
  ],
  "/darshan-booking": [
    { label: "Home", path: "/" },
    ,
    { label: "Online Darshan Booking", path: "/services/darshan-booking" },
    { label: "Darshan Booking", path: "/darshan-booking" },
  ],
  "/pooja-at-temple": [
    { label: "Home", path: "/" },
    ,
    { label: "Temple Puja Booking", path: "/services/temple-puja" },
    { label: "Puja At Temple", path: "/pooja-at-temple" },
  ],
  "/prasad-list": [
    { label: "Home", path: "/" },
    ,
    {
      label: "Online Prasad Booking Service",
      path: "/services/online-prasad-booking",
    },
    { label: "Prasad Booking", path: "/prasad-list" },
  ],
  "/horoscope": [
    { label: "Home", path: "/" },
    ,
    { label: "Horoscope Reading", path: "/services/horoscope" },
    { label: "Horoscope", path: "/horoscope" },
    ,
  ],
  "/astrology-list": [
    { label: "Home", path: "/" },
    ,
    { label: "Horoscope Reading", path: "/services/horoscope" },
    { label: "Horoscope", path: "/horoscope" },
    { label: "Astrology", path: "/astrology-list" },
  ],
  "/daily-panchang": [
    { label: "Home", path: "/" },
    ,
    { label: "Horoscope Reading", path: "/services/horoscope" },
    { label: "Horoscope", path: "/horoscope" },
    { label: "Daily Panchang", path: "/daily-panchang" },
    ,
  ],
  "/numerology": [
    { label: "Home", path: "/" },
    ,
    { label: "Horoscope Reading", path: "/services/horoscope" },
    { label: "Horoscope", path: "/horoscope" },
    { label: "Numerology", path: "/numerology" },
  ],
  "/Prediction": [
    { label: "Home", path: "/" },
    ,
    { label: "Horoscope Reading", path: "/services/horoscope" },
    { label: "Horoscope", path: "/horoscope" },
    { label: "Prediction", path: "/Prediction" },
  ],
  "/horoscope/my-profile": [
    { label: "Home", path: "/" },
    ,
    { label: "Horoscope Reading", path: "/services/horoscope" },
    { label: "Horoscope", path: "/horoscope" },
    { label: "My Profile", path: "/horoscope/my-profile" },
  ],
  "/my-profile": [
    { label: "Home", path: "/" },
    ,
    { label: "My Profile", path: "/my-profile" },
  ],
  //   "/settings/profile": ["Home", "Settings", "Profile"],
  // Add only the pages where you want breadcrumbs
};

export default breadcrumbConfig;
